import React from "react";
import { getTripStatusUi, sortTripsByDateTime } from "./tripUtils";

export default function TripCard({
  trip,
  trips,
  selectedTripId,
  menuOpenId,
  menuRefs,
  onSelectTrip,
  onMenuToggle,
  onOpenBookingDetails,
  onPhoneCancel,
  onPrepareCancel,
  onUndoCancel,
}) {
  const cancelStatus = trip.cancellationStatus;
  const cannotCancel = cancelStatus === 0;
  const phoneCancel = cancelStatus === 1;

  const {
    isCancelled,
    isRefused,
    isUnallocated,
    undoCancel,
    isPastTrip,
    quickStatus,
    tabText,
    tabColor,
  } = getTripStatusUi(trip);

  return (
    <div
      className={`trip-card ${
        selectedTripId === trip.id ? "selected" : ""
      } ${isCancelled || isRefused ? "cancelled" : ""} ${
        isUnallocated ? "unallocated" : ""
      } ${menuOpenId === trip.id ? "menu-open" : ""} ${
        isPastTrip ? "past-trip" : ""
      }`}
      onClick={() => onSelectTrip(trip)}
    >
      <div
        className="trip-icon"
        style={{ backgroundColor: tabColor }}
        title={quickStatus}
      >
        <span className="trip-text">{tabText}</span>
      </div>

      <div>
        <strong>
          <span title={trip.date}>
            {trip.formatteddate} at {trip.time}
          </span>
        </strong>
      </div>

      <div>
        <strong>From:</strong> {trip.from.name}
      </div>

      <div>
        <strong>To:</strong> {trip.to.name}
      </div>

      <div
        className="card-menu"
        ref={(el) => (menuRefs.current[trip.id] = el)}
      >
        <button
          className="menu-btn"
          onClick={(e) => {
            e.stopPropagation();
            onMenuToggle(trip.id);
            onSelectTrip(trip);
          }}
        >
          &#8942;
        </button>

        {menuOpenId === trip.id && (
          <ul className="menu-dropdown">
            <li
              onClick={() => {
                const tripsInBooking = sortTripsByDateTime(
                  trips.filter((t) => t.bookingId === trip.bookingId),
                );

                onOpenBookingDetails(tripsInBooking);
              }}
            >
              Open Booking Details
            </li>

            {!cannotCancel && !isPastTrip && !undoCancel && (
              <li
                onClick={() => {
                  if (phoneCancel) {
                    onPhoneCancel();
                    return;
                  }

                  onPrepareCancel(trip);
                }}
              >
                Cancel Trip
              </li>
            )}

            {undoCancel && (
              <li
                onClick={() => {
                  onUndoCancel(trip);
                }}
              >
                Undo Cancel?
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
}
